// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"BrokerOfferModal_modalWrapper__uU2qU","modalCol":"BrokerOfferModal_modalCol__pzfSe"};